const TOP_SCORES_TABS = {
  ASSIST_TOPSCORER: {
    label: "Assist",
    value: "ASSIST_TOPSCORER",
    order: 2
  },
  GOAL_TOPSCORER: {
    label: "Goal",
    value: "GOAL_TOPSCORER",
    order: 1
  },
  MISSED_PENALTY_TOPSCORER: {
    label: "Missed penalty",
    value: "MISSED_PENALTY_TOPSCORER",
    order: 2
  },
  PENALTY_TOPSCORER: {
    label: "Penalty",
    value: "PENALTY_TOPSCORER",
    order: 0
  },
  REDCARDS: {
    label: "Red cards",
    value: "REDCARDS",
    order: 2
  },
  YELLOWCARDS: {
    label: "Yellow cards",
    value: "YELLOWCARDS",
    order: 2
  },
  ALL: {
    label: "All",
    value: "ALL",
    order: 2
  }
};
export {
  TOP_SCORES_TABS
};
